import Marquee from "react-fast-marquee";
import pfLogo from "../../images/brand/pfi.png";
import aggreLogo from "../../images/brand/aggre-capital.webp";
import growpathLogo from "../../images/brand/growpath.png";
import lampungFarmLogo from "../../images/brand/lampung-farm.png";



const BrandSection: React.FC = () => {
  return (
    <section className="brand pt-170 pb-150">
      <div className="container">
        <div className="xb-brand-wrap xb-border">
          <div className="brand-sub-title xb-border">
            <p>
              Trusted by <span>Leading Companies</span> in Indonesia
            </p>
          </div>

          <Marquee speed={40} gradient={false} pauseOnHover={true}>
            <div style={{ display: "flex", alignItems: "center" }}>
              {[
                { src: aggreLogo, alt: "Aggre Capital" },
                { src: pfLogo, alt: "Pathfinder" },
                { src: growpathLogo, alt: "Growpath Distribution Indonesia" },
                { src: lampungFarmLogo, alt: "Lampung Farm Solution" },
              ].map((logo, i) => (
                <div key={i} className="brand-logo-item" style={{ display: "flex", alignItems: "center", padding: "16px 48px" }}>
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="brand-logo-img"
                    style={{ height: 64, width: "auto", maxWidth: 160, objectFit: "contain", filter: "brightness(0) opacity(0.6)" }}
                  />
                </div>
              ))}
            </div>
          </Marquee>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
